var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('divHeader'),(_vm.$store.state.login)?_c('divLogin'):_vm._e(),_c('router-view'),_c('divFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }